<script setup>
import { VueFinalModal } from "vue-final-modal";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import Icon from "../../Common/Icon.vue";

const { t } = useI18n();

const emit = defineEmits(["close", "submit"]);
const defaultName = t("filter.collection.new-name");
const name = ref("");
const inputRef = ref(null);

function onOpened() {
  inputRef.value.focus();
}

function onSubmit() {
  emit("submit", name.value ? name.value : defaultName);
}
</script>

<template>
  <VueFinalModal
    content-transition="vfm-slide-bottom"
    content-class="bg-light p-5 sm:p-10 lg:px-20 w-full sm:w-auto max-w-full"
    class="flex items-center justify-center p-5"
    style="background-color: rgba(0, 0, 0, 0.5)"
    :hide-overlay="true"
    @opened="onOpened()"
  >
    <form @submit.prevent="onSubmit()">
      <label for="name" v-t="'filter.collection.new.label'" class="block mb-2 text-16 text-dark/50"></label>
      <input
        type="text"
        name="name"
        id="name"
        v-model="name"
        ref="inputRef"
        :placeholder="defaultName"
        class="w-full bg-white sm:w-72 lg:w-96 border text-16 lg:text-20 border-dark/20 px-5 py-3 focus:border-primary/40 outline-none transition-colors mb-5"
      />
      <div class="flex gap-x-6 items-center text-16">
        <button v-t="'filter.collection.new.save'" class="bg-primary text-white px-5 py-2"></button>

        <button
          @click="emit('close')"
          type="button"
          class="text-left font-medium flex items-center gap-x-3 text-dark/50 hover:text-dark transition-colors"
        >
          <span v-t="'filter.collection.new.cancel'"></span>
        </button>
      </div>
    </form>
  </VueFinalModal>
</template>
